// Petit écran de caisse : hauteur <= 854px (lue une seule fois au chargement).
// Dans ce cas seul le menu du bas est utilisé, masqué derrière un bouton flottant.
export const SMALL_SCREEN_MAX_HEIGHT = 854;

export const isSmallScreen = window.innerHeight <= SMALL_SCREEN_MAX_HEIGHT;

// Hauteur réservée au menu du bas (0 sur petit écran car il est masqué)
export const BOTTOM_MENU_HEIGHT = isSmallScreen ? "0px" : "130px";

// Largeur du panneau de paiement sur petit écran
export const SMALL_PAYMENT_WIDTH = "40%";
